<div class="filter-by-event-type">
  <div
    class="remove-date-container"
    fxLayout="row"
    fxLayoutAlign="start center"
    (click)="clearDateFilter()"
  >
    <mat-icon class="mat-icon">close</mat-icon> <span>Clear date</span>
  </div>
  <div
    class="date-input-container"
    fxLayout="row"
    fxLayoutGap="5px"
    fxLayoutAlign="space-between"
  >
    <div fxLayout="column" fxFlex="45">
      <span class="title-date-input">Start Date</span>
      <input
        readonly
        type="text"
        [ngModel]="date.startDate"
        (focus)="onFocus('startDate')"
      />
    </div>
    <div fxLayout="column" fxFlex="45">
      <span>End Date</span>
      <input
        readonly
        type="text"
        [ngModel]="date.endDate"
        (focus)="onFocus('endDate')"
      />
    </div>
  </div>
  <hr class="line-card" />
  <div>
    <mat-calendar (selectedChange)="onSelect($event)"> </mat-calendar>
  </div>
</div>
